import { ChangeDetectorRef, Component, DestroyRef, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { CompanyService } from 'src/app/services/companies-services/company.service';
import { Subscription, Observable, empty } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { ProductModel } from 'src/app/models/product.model';
import { ApplicationModel } from 'src/app/models/application.model';
import { CenterTypeModel } from 'src/app/models/centertype.model';
import { TIMEZONES } from 'src/assets/timezones/timezones';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

declare var google;

@Component({
    selector: 'app-companies-new-company-creation-card',
    templateUrl: './companies-new-company-creation-card.component.html',
    styleUrls: ['./companies-new-company-creation-card.component.scss'],
    standalone: false
})
export class CompaniesNewCompanyCreationCardComponent implements OnInit, OnChanges {

  @ViewChild('companyUploadInput', { static: false }) companyUploadInput: ElementRef;
  @ViewChild('centerUploadInput', { static: false }) centerUploadInput: ElementRef;
  @ViewChild('map', { static: false }) map: ElementRef;
  @Input() countries: string[];
  @Input() products: ProductModel[];
  @Input() applications: ApplicationModel[];
  @Input() centerTypes: CenterTypeModel[];
  @Input() timezones;
  showProductsForm;
  showApplicationsForm;

  userCreationFormErrorMessage: string;
  addNewCompanySubscription: Subscription;
  mapInstance;
  showMap;
  createdCompany;
  loading: boolean;
  logCreatingCompany = [];
  logCreatingProducts = [];
  logCreatingApplications = [];

  constructor(private companyService: CompanyService,
              private cd: ChangeDetectorRef,
              private destroyRef: DestroyRef) {
              }

  productsForm = new UntypedFormGroup({});
  applicationsForm = new UntypedFormGroup({});
  newCompanyForm = new UntypedFormGroup({
    active: new UntypedFormControl(true),
    companyComercialName: new UntypedFormControl(null, Validators.required),
    companyCif: new UntypedFormControl(null, Validators.required),
    companyFiscalName: new UntypedFormControl(null, Validators.required),
    companyAddress: new UntypedFormControl(null),
    companyCity: new UntypedFormControl(null),
    companyPostalCode: new UntypedFormControl(null),
    companyProvince: new UntypedFormControl(null),
    companyRegion: new UntypedFormControl(null),
    companyCountry: new UntypedFormControl(null, Validators.required),
    companyFax: new UntypedFormControl(null),
    companyPhone: new UntypedFormControl(null),
    companyWeb: new UntypedFormControl(null),
    companyEmail: new UntypedFormControl(null, Validators.email),
    companyImageRaw: new UntypedFormControl(null, Validators.required),
    companyImageType: new UntypedFormControl(null, Validators.required),
    userEmail: new UntypedFormControl(null, [Validators.required, Validators.email]),
    userPassword: new UntypedFormControl(null, Validators.required),
    userFirstname: new UntypedFormControl(null, Validators.required),
    userLastname: new UntypedFormControl(null, Validators.required),
    centerComercialName: new UntypedFormControl(null, Validators.required),
    centerCode: new UntypedFormControl(null),
    centerCif: new UntypedFormControl(null),
    centerFiscalName: new UntypedFormControl(null),
    centerFiscalAddress: new UntypedFormControl(null),
    centerAddress: new UntypedFormControl(null, Validators.required),
    centerCity: new UntypedFormControl(null, Validators.required),
    centerPostalCode: new UntypedFormControl(null, Validators.required),
    centerProvince: new UntypedFormControl(null, Validators.required),
    centerRegion: new UntypedFormControl(null, Validators.required),
    centerCountry: new UntypedFormControl(null, Validators.required),
    centerType: new UntypedFormControl(null, Validators.required),
    centerLatitude: new UntypedFormControl(null, Validators.required),
    centerLongitude: new UntypedFormControl(null, Validators.required),
    centerActive: new UntypedFormControl(true),
    centerVisible: new UntypedFormControl(true),
    centerImageRaw: new UntypedFormControl(null, Validators.required),
    centerImageType: new UntypedFormControl(null, Validators.required),
    centerUserFax: new UntypedFormControl(null),
    centerUserPhone: new UntypedFormControl(null, Validators.required),
    centerUserMail: new UntypedFormControl(null, [Validators.required, Validators.email]),
    centerUserContact: new UntypedFormControl(null, Validators.required),
    centerTimezone: new UntypedFormControl({ value: 'Europe/Madrid' }, Validators.required)
  });

  ngOnInit() { }

  ngOnChanges() {
    if (this.products && this.applications && (this.products.length > 0) && (this.applications.length > 0)) {
      this.setProductsForm();
      this.setApplicationsForm();
    }
  }

  public addNewCompany() {
    this.userCreationFormErrorMessage = '';
    const validation = this.validation();
    if (validation === true) {
      this.loading = true;
      this.logCreatingCompany.push('Creando datos básicos de compañía...');
      this.addNewCompanySubscription = this.companyService.addNewCompany(this.newCompanyForm).pipe(
        takeUntilDestroyed(this.destroyRef),
        tap(res => this.logCreatingCompany.push('Compañía creada')),
        tap(res => this.createdCompany = res),
        tap(res => Object.entries(this.productsForm.value).forEach(p => {
          if (p[1]) {
            this.logCreatingProducts.push('Añadiendo producto ' + p[0] + '...');
            this.companyService.updateCompanyProduct(res.internalId, p[0], p[1]).pipe(
              takeUntilDestroyed(this.destroyRef),
              tap(o => this.logCreatingProducts.push('Añadido'))
            ).subscribe();
          }
        })),
        tap(res => Object.entries(this.applicationsForm.value).forEach(a => {
          if (a[1]) {
            this.logCreatingApplications.push('Añadiendo aplicación ' + a[0] + '...');
            this.companyService.updateCompanyApplication(res.internalId, a[0], a[1]).pipe(
              takeUntilDestroyed(this.destroyRef),
              tap(o => this.logCreatingApplications.push('Añadido'))
            ).subscribe();
          }
        })),
        catchError(err => {
          this.userCreationFormErrorMessage = err;
          this.loading = true;
          return empty();
        })
      ).subscribe();
    }
  }

  public getActiveProducts() {
    const enabledProducts = [];
    if (this.productsForm && (Object.entries(this.productsForm.value).length > 0)) {
      Object.entries(this.productsForm.value).forEach(c => {
        if (c[1]) {
          enabledProducts.push(this.products.find(p => p.mproductCode === c[0]));
        }
      });
      return enabledProducts;
    }
    return [];
  }

  private validation() {
    if (this.newCompanyForm.valid) {
      return true;
    }
    this.newCompanyForm.markAllAsTouched();
  }

  public companyUploadInputChanged(event) {
    const files = this.companyUploadInput.nativeElement.files;
    this.toBase64(files[0]).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (res) => {
        this.newCompanyForm.patchValue({
          companyImageType: 'IMAGE',
          companyImageRaw: res
        });
      }
    );
  }
  public centerUploadInputChanged(event) {
    const files = this.centerUploadInput.nativeElement.files;
    this.toBase64(files[0]).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(
      (res) => {
        this.newCompanyForm.patchValue({
          centerImageType: 'IMAGE',
          centerImageRaw: res
        });
      }
    );
  }

  private toBase64(file) {
    return new Observable(
      (o) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          o.next(reader.result);
        };
        reader.onerror = (error) => {
          o.error(error);
        };
      }
    );
  }

  public hasError(field) {
    const formControl = this.newCompanyForm.get(field);
    if (formControl.touched && formControl.invalid) {
      if (formControl.errors.required) {
        return '* Campo obligatorio';
      }
      return '* Campo ' + field + ' inválido';
    }
    return false;
  }

  public onAddressChange(e) {
    let address = '';
    this.newCompanyForm.get('centerAddress').value ? address += this.newCompanyForm.get('centerAddress').value + ', ' : address += '';
    this.newCompanyForm.get('centerCity').value ? address += this.newCompanyForm.get('centerCity').value + ', ' : address += '';
    this.newCompanyForm.get('centerPostalCode').value ? address += this.newCompanyForm.get('centerPostalCode').value + ', ' : address += '';
    this.newCompanyForm.get('centerProvince').value ? address += this.newCompanyForm.get('centerProvince').value + ', ' : address += '';
    this.newCompanyForm.get('centerRegion').value ? address += this.newCompanyForm.get('centerRegion').value + ', ' : address += '';
    this.newCompanyForm.get('centerCountry').value ? address += this.newCompanyForm.get('centerCountry').value + ', ' : address += '';

    this.companyService.getGpsLocationFromAddress(address).pipe(
      takeUntilDestroyed(this.destroyRef),
      tap(res => this.newCompanyForm.patchValue({
        centerLatitude: res['lat'],
        centerLongitude: res['lng']
      })),
      tap(res => this.initMap())
    ).subscribe();
  }

  public onGPSChange(e) {
    this.initMap();
  }

  private setProductsForm() {
    this.products.forEach((p: ProductModel) => {
      const control = new UntypedFormControl(false);
      this.productsForm.addControl(p.mproductCode, control);
    });
    this.showProductsForm = true;
  }

  private setApplicationsForm() {
    this.applications.forEach((a: ApplicationModel) => {
      const control = new UntypedFormControl(false);
      this.applicationsForm.addControl(a.applicationName, control);
    });
    this.showApplicationsForm = true;
  }

  private initMap() {
    this.showMap = true;
    this.cd.detectChanges();
    this.mapInstance = new google.maps.Map(this.map.nativeElement, {
      zoom: 18,
      center: new google.maps.LatLng(this.newCompanyForm.get('centerLatitude').value, this.newCompanyForm.get('centerLongitude').value),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false });
    const marker = new google.maps.Marker({
      position: new google.maps.LatLng(this.newCompanyForm.get('centerLatitude').value, this.newCompanyForm.get('centerLongitude').value),
      map: this.mapInstance });
  }

  public setPreselected2(op1, op2) {
    if (op1 && op2) {
      return op1 === op2;
    }
  }

}
